/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import KeyboardAltIcon from '@mui/icons-material/KeyboardAlt';
import {FolderShared} from "@mui/icons-material";

const modernInfo = [
    {
        title: 'Studio quality recording anywhere',
        subtitle:
            'Record crystal-clear audio and 4K video even when guests have poor connections.',
        icon: (
            <VideoCameraFrontIcon/>
        ),
    },
    {
        title: 'Editing that feels familiar',
        subtitle:
            'Edit your video by editing text—no complicated software or timelines required.',
        icon: (
            <KeyboardAltIcon/>
        ),
    },
    {
        title: 'Instant sharing & publishing',
        subtitle:
            'Send projects to collaborators or export ready-to-post files in a single click.',
        icon: (
            <FolderShared/>
        ),
    },
];

const mock = [
    {
        title: 'High-quality remote recording',
        subtitle:
            'Record high-definition audio and video with remote guests. Everyone gets a local copy, even with bad internet.',
        icon: (
            <VideoCameraFrontIcon/>
        ),
    },
    {
        title: 'Edit video by editing text',
        subtitle:
            'Libretto transcribes your recordings and uploads so you can cut, copy and rearrange text to edit the timeline.',
        icon: (
            <KeyboardAltIcon/>
        ),
    },
    {
        title: 'One-click project sharing',
        subtitle:
            'Invite collaborators or export final files instantly—no third party services required.',
        icon: (
            <FolderShared/>
        ),
    },
];

export const ModernServices = () => {
    const theme = useTheme();
    return (
        <Box display={"flex"} alignItems={"center"} flexDirection={"column"}>
            <Box marginBottom={3} maxWidth={{ xs: "95%", sm: 720, md: 1236 }}>
                <Box marginBottom={2}>
                    <Typography
                        variant="h3"
                        color="text.primary"
                        align={'center'}
                        gutterBottom
                        sx={{
                            fontWeight: 700,
                        }}
                    >
                        One studio for every creator
                    </Typography>
                    <Box
                        sx={{
                            fontSize: { xs: "21px", sm: "23px", md: "24px" }, // Smaller font for mobile
                            marginTop: "15px",
                            marginBottom: { xs: "-10px"},
                            fontWeight: "500",
                            color: "#6f6e77",
                            textAlign: "center", // Center align the text
                            paddingX: { xs: "20px", sm: "0" } // Padding on mobile for better spacing
                        }}
                    >
                        Libretto combines recording, editing and publishing in a single place.
                    </Box>
                </Box>
            </Box>
            <Grid container maxWidth={{ xs: "95%", sm: 720, md: 1236 }} spacing={2}>
                {modernInfo.map((item, i) => (
                    <Grid item xs={12} md={4} key={i}>
                        <Box width={1} height={1}>
                            <Box
                                display={'flex'}
                                flexDirection={'column'}
                                alignItems={'center'}
                            >
                                <Box
                                    component={Avatar}
                                    width={60}
                                    height={60}
                                    marginBottom={2}
                                    bgcolor={alpha(theme.palette.primary.main, 0.1)}
                                    color={"#2B6BFD"}
                                >
                                    {item.icon}
                                </Box>
                                <Typography
                                    variant={'h6'}
                                    gutterBottom
                                    sx={{ fontWeight: 550 }}
                                    align={'center'}
                                >
                                    {item.title}
                                </Typography>
                                <Typography align={'center'} color="text.secondary" fontFamily={"Inter"} fontSize={"1.1rem"} fontWeight={400}>
                                    {item.subtitle}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export const NewServices = () => {
    const theme = useTheme();
    return (
        <Box>
            <Box marginBottom={4}>
                <Box marginBottom={2}>
                    <Typography
                        variant="h3"
                        color="text.primary"
                        align={'center'}
                        gutterBottom
                        sx={{
                            fontWeight: 700,
                        }}
                    >
                        Studio-quality recording + editing
                    </Typography>
                    <Typography
                        variant="h6"
                        component="p"
                        fontFamily={"Inter"}
                        color="text.secondary"
                        sx={{ fontWeight: 400 }}
                        align={'center'}
                    >
                        Record high-quality audio & video, edit with an intelligent editor and share content in one click.
                    </Typography>
                </Box>
            </Box>
            <Grid container spacing={2}>
                {mock.map((item, i) => (
                    <Grid item xs={12} md={4} key={i}>
                        <Box width={1} height={1}>
                            <Box
                                display={'flex'}
                                flexDirection={'column'}
                                alignItems={'center'}
                            >
                                <Box
                                    component={Avatar}
                                    width={60}
                                    height={60}
                                    marginBottom={2}
                                    bgcolor={alpha(theme.palette.primary.main, 0.1)}
                                    color={"#2B6BFD"}
                                >
                                    {item.icon}
                                </Box>
                                <Typography
                                    variant={'h6'}
                                    gutterBottom
                                    sx={{ fontWeight: 500 }}
                                    align={'center'}
                                >
                                    {item.title}
                                </Typography>
                                <Typography align={'center'} color="text.secondary" fontFamily={"Inter"} fontSize={"1.1rem"} fontWeight={500}>
                                    {item.subtitle}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

const Services = () => {
    const theme = useTheme();
    return (
        <Box>
            <Box marginBottom={4}>
                <Box marginBottom={2}>
                    <Typography
                        variant="h3"
                        color="text.primary"
                        align={'center'}
                        gutterBottom
                        sx={{
                            fontWeight: 700,
                        }}
                    >
                        Podcasting made
                        {' '}<Typography
                            color={'primary'}
                            component={'span'}
                            variant={'inherit'}
                        >
                            simple
                        </Typography>
                    </Typography>
                    <Typography
                        variant="h6"
                        component="p"
                        color="text.secondary"
                        sx={{ fontWeight: 600 }}
                        align={'center'}
                    >
                        Record high-quality audio & video, and edit with a collaborative editor and automated audio post production.
                    </Typography>
                </Box>
            </Box>
            <Grid container spacing={2}>
                {mock.map((item, i) => (
                    <Grid item xs={12} md={4} key={i}>
                        <Box width={1} height={1}>
                            <Box
                                display={'flex'}
                                flexDirection={'column'}
                                alignItems={'center'}
                            >
                                <Box
                                    component={Avatar}
                                    width={60}
                                    height={60}
                                    marginBottom={2}
                                    bgcolor={alpha(theme.palette.primary.main, 0.1)}
                                    color={theme.palette.primary.main}
                                >
                                    {item.icon}
                                </Box>
                                <Typography
                                    variant={'h6'}
                                    gutterBottom
                                    sx={{ fontWeight: 500 }}
                                    align={'center'}
                                >
                                    {item.title}
                                </Typography>
                                <Typography align={'center'} color="text.secondary" fontSize={"1.1rem"} fontWeight={500}>
                                    {item.subtitle}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Services;
